const multiTabs = {
  namespaced: true,
  state: {
    list: [],
    current: null,
    cacheRouter: ''
  },
  mutations: {
    setList (state, list) {
      state.list = list
    },
    setCurrent (state, current) {
      state.current = current
    },
    setCacheRouter (state, cacheRouter) {
      state.cacheRouter = cacheRouter
    }
  }
}

export default multiTabs
